import axios from 'axios';

export const groupApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/groups`,
    headers: {
        'Content-Type': 'application/json'
    }
})